// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconHealthPath = 'm2.898 9.193 7.092 6.828 2.046-1.972 1.388 1.44-3.433 3.309-8.494-8.177A5.033 5.033 0 0 1 0 7.041c0-1.352.529-2.617 1.488-3.563A5.071 5.071 0 0 1 5.07 2c1.352 0 2.628.525 3.593 1.48l1.329 1.327 1.343-1.337a4.977 4.977 0 0 1 2.714-1.387c.092-.027.174-.037.236-.04a5.069 5.069 0 0 1 4.227 1.425A5.019 5.019 0 0 1 20 7.04a4.932 4.932 0 0 1-1.064 3.078l-1.572-1.237A2.95 2.95 0 0 0 18 7.041c0-.81-.32-1.576-.897-2.155-.642-.634-1.566-.965-2.44-.876l-.074.05h-.233a2.996 2.996 0 0 0-1.615.832l-2.752 2.74-2.736-2.735c-1.164-1.149-3.178-1.162-4.36.004A2.982 2.982 0 0 0 2 7.041c0 .808.319 1.573.898 2.152ZM13.89 6.581l1.833 6L16.689 11h3.31v2h-2.188l-2.701 4.419-1.833-6-.966 1.58h-3.31v-2h2.188l2.701-4.418Z';
var IconHealth = baseIcon('IconHealth', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconHealthPath
});
export default IconHealth;
//# sourceMappingURL=index.js.map